/**
 * The tracks: each file in `music/tracks/` registers its own (`registerTrack`), and library.ts
 * loads them all. Old mood names (town, field …, still used by cutscene data) map to tracks.
 */
import type { TrackDef } from './types';

const TRACKS = new Map<string, TrackDef>();

export function registerTrack(def: TrackDef): TrackDef {
  if (TRACKS.has(def.id)) throw new Error(`track "${def.id}" registered twice`);
  TRACKS.set(def.id, def);
  return def;
}

/** Every track, in listing order. */
export const allTracks = (): TrackDef[] => [...TRACKS.values()].sort((a, b) => a.order - b.order);

/** The moods of the first sound engine, still named in data (cutscenes), and the track each now plays. */
export const ALIASES: Readonly<Record<string, string>> = {
  town: 'yanyu',
  field: 'wilds',
  snow: 'snow',
  battle: 'battle',
  boss: 'boss',
  jail: 'jail',
};

/** The track for an id or an old mood name; null for 'none' or an unknown name. */
export function resolveTrack(id: string | null | undefined): TrackDef | null {
  if (!id || id === 'none') return null;
  return TRACKS.get(id) ?? TRACKS.get(ALIASES[id] ?? '') ?? null;
}
